'use strict';

class ProductPrice {
    constructor(url, stockNumber) {
        this.url = url;
        this.stockNumber = stockNumber;
    }

    /**
     * Fetch the product information from the data source.
     * @returns {Object}
     */
    getProduct() {
        let ids = [];

        ids.push(this.stockNumber);

        return $.ajax({
            url: this.url,
            data: {'id':ids},
            dataType: 'json'
        });
    }
}

$(window).load(function () {
    $('.product-price').each((key, element) => {

        const url = element.dataset.url;
        const stockNumber = element.dataset.stocknumber;

        if (!url && !stockNumber) {
            return null;
        }

        (new ProductPrice(url, stockNumber)).getProduct().always(data => {
            const product = data[0];
            if (product && product.displayPrice) {
                $(element).removeClass('hidden');
                $(element).find('.product-price__price').text(product.displayPrice);
            }
        });
    });
});



// WEBPACK FOOTER //
// ./src/js/components/product-price.js